/** Locale display format used across the UI (e.g. "31/12/2024"). */
export const STANDARD_DATE_FORMAT = 'dd/MM/yyyy';
/** Locale display date-time format used across the UI (e.g. "31/12/2024 15:45"). */
export const STANDARD_DATE_TIME_FORMAT = `${STANDARD_DATE_FORMAT} HH:mm`;
/** US-style month-first display format (e.g. "12/31/2024"). */
export const US_DATE_FORMAT = 'MM/dd/yyyy';
/** ISO short form used in API payloads. */
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
/** Day + abbreviated month (e.g. "31/Dec"). */
export const DATE_MONTH_FORMAT = 'dd/MMM';
/** Long display format with full month abbreviation (e.g. "31 Dec 2024"). */
export const DATE_LONG_FORMAT = 'dd MMM yyyy';
